import React from 'react';
import Article from './Article';
import frequencyAnalysisData from '../data/frequencyAnalysis.json';

function Home() {
  return (
    <main className="min-h-screen">
      {/* Space for future anime.js animation */}
      

      <div className="max-w-6xl mx-auto px-6 py-20">
        {/* Hero Section */}
        <section className="mb-20">
          <h1 className="text-6xl font-bold text-gray-900 mb-6">
            Ethan Guttman - Aspiring Actuary
          </h1>
        </section>

        {/* About Section */}
        <section className="border rounded bg-white mb-20 p-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">About Me</h2>
          <p className="text-lg text-gray-700 leading-relaxed max-w-3xl">
            Computer Science graduate (Seattle University '21) and former xAI engineer with four years of experience in data-heavy applications and AI training. 
            I'm bringing my programming expertise into the actuarial field and have passed SOA Exams P, FM, and SRM. I'm seeking entry-level actuarial roles, especially on teams modernizing their tools and workflows.
            In the articles here, I explore math, probability, and finance concepts as I deepen my own understanding. Below is my current featured article.
          </p>
        </section>

        {/* Featured Article */}
        <section>
          <h2 className="text-3xl font-bold text-gray-900 mb-8">Featured Article</h2>
          <Article data={frequencyAnalysisData} />
        </section>
      </div>

      {/* Footer */}
      <footer className="border-t border-gray-200 mt-20">
        <div className="max-w-6xl mx-auto px-6 py-8">
          <p className="text-gray-600 text-center">
            © 2026 Ethan Guttman. All rights reserved.
          </p>
        </div>
      </footer>
    </main>
  );
}

export default Home;
